import { render, staticRenderFns } from "./DrinksPerWeekDay.vue?vue&type=template&id=ece0a3da&scoped=true&"
import script from "./DrinksPerWeekDay.vue?vue&type=script&lang=ts&"
export * from "./DrinksPerWeekDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece0a3da",
  null
  
)

export default component.exports